import AnexosComp from './AnexosComp'
export default AnexosComp



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Anexos/index.js